import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VATSubmissionForm from "components/VATSubmissionForm";
import { TC } from "../tokens/text";

function VATSubmissionPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <Card sx={{ p: 3 }}>
          <VuiTypography variant="lg" mb={2} sx={{ color: TC.primary }}>
            Submit VAT Return
          </VuiTypography>
          <VATSubmissionForm />
        </Card>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default VATSubmissionPage;


